__turbopack_context__.v({
  "card": "About-module-scss-module__6V3fMW__card",
  "card-list": "About-module-scss-module__6V3fMW__card-list",
  "card-list-item": "About-module-scss-module__6V3fMW__card-list-item",
  "founders-image": "About-module-scss-module__6V3fMW__founders-image",
  "hero": "About-module-scss-module__6V3fMW__hero",
  "split-layout": "About-module-scss-module__6V3fMW__split-layout",
});
